import { useEffect, useState } from 'react'
import { Row, Col, Card, Form, InputGroup, FormControl, Button } from 'react-bootstrap'
import Get from '../../../api/Get'
import { DISEASE_GET_ALL_NEW } from '../../../api/Routes'
import SimpleTable from '../../../components/SimpleTable'
import ReactPaginate from 'react-paginate';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri'
import { FaPen, FaSearch } from 'react-icons/fa'

export default function DiagnosticoList({setLoading, auth, setShowModalError, setErrorServer, getToEdit, recheck}){
    const [items, setItems] = useState([])
    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(20)
    const [sortBy, setSortBy] = useState('id')
    const [pageCount, setPageCount] = useState(0)
    const [name, setName] = useState('%20')
    const [filterContent, setFilterContent] = useState('')

    useEffect(() => {
        setLoading(true)
        Get({url: `${DISEASE_GET_ALL_NEW}/${pageNo}/${pageSize}/${sortBy}/asc/true/${name}`, access_token: auth.data.access_token})
        .then((resp) => {
            console.log(resp.data)
            if(resp.data.state){
                setItems(resp.data.data.response.content)
                setPageCount(resp.data.data.response.totalPages)
            }
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [pageNo, pageSize, recheck, name])

    const actions = (cell, row) => (
        <div>
            <FaPen className='iconAction colorNaranja float-right' onClick={e=>getToEdit(row)}/>
        </div>
    )

    const columns = [
        {
            text: 'ID',
            dataField: 'id',
            hidden:true
        },  
        {
            dataField: 'code4digits',
            text: 'Código',
            headerStyle: { width: '20%' },
        },
        {
            dataField: 'description',
            text: 'Descripción',
            headerStyle: { width: '50%' },
        }, 
        {
            dataField: 'active',
            text: 'Activo',
            headerStyle: { width: '10%' },
            formatter: (cell) => `${cell ? 'Si': 'No'}`,
        },
        {
            dataField: 'common',
            text: 'Común',
            headerStyle: { width: '10%' },
            formatter: (cell) => `${cell ? 'Si': 'No'}`,
        },
        {
            dataField: '',
            isDummyField: true,
            text: 'ACCIONES',
            headerStyle: {  width: '10%', },
            formatter: actions,
            editable:false,
        }
    ]
    const handlePageClick = (data) => setPageNo(data.selected);

    const handleSearchChange = (e) => setFilterContent(e.target.value)
    const handleNameChannge = (e) => {
        e.preventDefault()
        setName(filterContent===''?'%20':filterContent)
    }

    return (<>
        <Card className="shadow-1 mt-3">
            <Card.Body>
                <Row className="justify-content-end">
                    <Col xs="8" md="5">
                        <Form onSubmit={handleNameChannge}>
                            <InputGroup>
                                <FormControl
                                    type="text"
                                    value={filterContent}
                                    onChange={handleSearchChange}
                                    placeholder="Buscar"
                                    className="input-1"
                                />
                                <InputGroup.Append>
                                    <Button type="submit" variant="outline-secondary" className="input-span-1"><FaSearch/></Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </Form>
                    </Col>
                </Row>    
                <Row>
                    <Col>
                        <SimpleTable 
                            columns={columns} 
                            items={items}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="10">
                        <ReactPaginate
                            previousLabel={<RiArrowLeftSLine />}
                            nextLabel={<RiArrowRightSLine />}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />
                    </Col>
                    <Col className="d-none d-md-block" xs="12" md="2">
                        <select className="select-pagin" onChange={e=>setPageSize(e.target.value)}>
                            <option value="20">20 / página</option>
                            <option value="30">30 / página</option>
                            <option value="50">50 / página</option>
                        </select>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    </>)
}